// Landing-page on-ramp (Spec v1, revised 2026-06-17): a few curated example Style prompts.
// Clicking one pre-fills the *live* Style box so a first-time visitor immediately has a
// personal result to Improve — not a static demo.
interface Template {
  label: string
  style: string
}

const TEMPLATES: Template[] = [
  { label: '80s synthwave', style: 'retro synthwave, analog synths, gated-reverb drums, neon nostalgia, 110 BPM' },
  { label: 'Lo-fi study beat', style: 'lo-fi hip-hop, dusty vinyl crackle, mellow Rhodes piano, soft boom-bap drums, 75 BPM' },
  { label: 'Epic cinematic', style: 'cinematic orchestral, swelling strings, taiko drums, brass swells, building dynamics' },
  { label: 'Acoustic love ballad', style: 'intimate acoustic ballad, fingerpicked guitar, warm male vocals, gentle brushes, 68 BPM' },
  { label: 'Festival EDM', style: 'big-room EDM, sidechained synths, punchy kick, euphoric build and drop, 128 BPM' },
  { label: 'Dark trap', style: 'dark trap, booming 808s, eerie bells, hi-hat rolls, moody minor key, 140 BPM' },
]

export default function ShowcaseGallery({ onUse }: { onUse: (style: string) => void }) {
  return (
    <section>
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500">Start from an example</h2>
      <div className="mt-3 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {TEMPLATES.map((t) => (
          <button
            key={t.label}
            onClick={() => onUse(t.style)}
            className="rounded-xl border border-gray-800 bg-gray-900 p-4 text-left transition hover:border-primary-500"
          >
            <div className="font-semibold">{t.label}</div>
            <div className="mt-1 line-clamp-2 text-xs text-gray-500">{t.style}</div>
          </button>
        ))}
      </div>
    </section>
  )
}
